/**
 * Globally-mounted RefreshFromDbDialog host.
 *
 * Any surface that wants to open the dialog calls
 * `useRefreshFromDbDialogStore.getState().openRefreshDialog(...)`. Mounted
 * once at the App root so context menus can launch the dialog without
 * having to render it themselves.
 */

import { lazy, Suspense } from 'react';
import { useRefreshFromDbDialogStore } from '../store/refreshFromDbDialogStore';

// Mounted at the App root but rendered only while open, so the dialog itself is
// code-split: keeping it eager pulled the blueprint refresh surface into the
// boot chunk for every user, opened or not.
const RefreshFromDbDialog = lazy(() =>
  import('./RefreshFromDbDialog').then((m) => ({ default: m.RefreshFromDbDialog })),
);

export function GlobalRefreshFromDbDialog() {
  const isOpen = useRefreshFromDbDialogStore((s) => s.isOpen);
  const args = useRefreshFromDbDialogStore((s) => s.args);
  const closeRefreshDialog = useRefreshFromDbDialogStore(
    (s) => s.closeRefreshDialog,
  );

  if (!args) return null;

  return (
    <Suspense fallback={null}>
      <RefreshFromDbDialog
        open={isOpen}
        onOpenChange={(next) => {
          if (!next) closeRefreshDialog();
        }}
        folderPath={args.folderPath}
        linkLabel={args.linkLabel}
        link={args.link}
        blueprintDataTables={args.blueprintDataTables}
        onSuccess={args.onSuccess}
        activeLinkConnectionId={args.activeLinkConnectionId}
      />
    </Suspense>
  );
}
